module.exports = __webpack_public_path__ + "img/97.56ed9da6.jpg";